import { render } from "./AttendanceEventModal.vue?vue&type=template&id=6b44bda8"
import script from "./AttendanceEventModal.vue?vue&type=script&lang=js"
export * from "./AttendanceEventModal.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__